<template>
  <div class="ModelCompare">
    <div id="model1" class="model"></div>
    <div class="myBorder">
      <el-button
        @click="ModelCompare"
        class="myborder-el-button"
        title="比对"
        icon="el-icon-s-help"
        circle
      ></el-button>
      <div class="divs">
        <div title="删除">删除</div>
        <div title="增加">增加</div>
        <div title="变更前">变更前</div>
        <div title="变更后">变更后</div>
      </div>
    </div>
    <div id="model2" class="model model3"></div>
    <el-select
      class="modelListOne"
      @change="model1Change"
      v-model="model1"
      placeholder="请选择"
    >
      <el-option
        v-for="(item, index) in modelList"
        :key="index"
        :label="item.name"
        :value="[item.name, item.path]"
      ></el-option>
    </el-select>
    <el-select
      class="modelListTwo"
      @change="model2Change"
      v-model="model2"
      placeholder="请选择"
    >
      <el-option
        v-for="(item, index) in modelList"
        :key="index"
        :label="item.name"
        :value="[item.name, item.path]"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modelList: null,
      model1: "",
      model2: "",
      model1Nanme: "",
      model1Nanme: "",
      model1Path: "",
      model2Path: "",
      loading: null,
    };
  },
  created() {
    var _this = this;
    var search = window.location.hash
      .substr(1)
      .split("=")[1]
      .replace(/%3D/g, "=");
    search = Base64.decode(search);
    // debugger
    _this.modelList = JSON.parse(search);
    // _this.modelList = _this.options;
    // _this.model1 = _this.model2 = _this.modelList[0].name;
  },
  methods: {
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "比对中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    model1Change(val) {
      this.model1Nanme = val[0];
      this.model1Path = val[1];
      var path = this.$store.state.baseUrl + val[1];
      modelCompare.viewer1Load(path);
    },
    model2Change(val) {
      this.model2Nanme = val[0];
      this.model2Path = val[1];
      var path = this.$store.state.baseUrl + val[1];
      modelCompare.viewer2Load(path);
    },
    ModelCompare() {
      if (this.model1 == "" || this.model2 == "") {
        this.$message({
          type: "warning",
          message: "请选择模型",
        });
      } else {
        if (!this.model1Path == this.model2Path) {
          this.$message({
            type: "warning",
            message: "请选择不同的模型进行比对",
          });
        } else if (modelCompare.viewer1IsLoad && modelCompare.viewer2IsLoad) {
          var length = modelCompare.getViewerLenth();
          var msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,是否进行比对？`;
          if (length[0] > 10000 || length[1] > 10000) {
            msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,
             检测到模型较大，比对时间较长，是否进行比对？`;
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.openFullScreen2();
            modelCompare.ModelCompare();
            var _Interval = setInterval(() => {
              if (modelCompare.compareComplete) {
                window.clearInterval(_Interval);
                this.loading.close();
                this.$message({
                  type: "success",
                  message: "比对完成",
                });
              }
            }, 1000);
          });
        } else {
          this.$message({
            type: "warning",
            message: "请等待模型加载完毕",
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.divs {
  width: 50px;
  font-size: 14px;
  text-align: center;
  position: absolute;
  height: 150px;
  padding-top: 50px;
  left: -1.45rem;
  margin-top: 2rem;
  z-index: 9;
  background: #00bcd4;
  border-radius: 0 0 10px 10px;
  div {
    width: 88%;
    height: 22px;
    border-radius: 2px;
    margin: 10px auto;
    &:nth-child(1) {
      background-color: rgb(255, 0, 0);
    }
    &:nth-child(2) {
      background-color: rgb(0, 128, 0);
    }
    &:nth-child(3) {
      background-color: rgb(218, 165, 32);
      color: #000000;
    }
    &:nth-child(4) {
      color: #000000;
      background-color: rgb(255, 255, 0);
    }
  }
}
.el-button {
  z-index: 99;
  background: #fff;
  color: #00bcd4;
  border: 0.25rem solid #00bcd4;
  font-size: 2rem;
}
.ModelCompare {
  .model {
    width: 49.6%;
    position: fixed;
    height: 100%;
    display: inline-flex;
  }
  .myBorder {
    z-index: 999;
    position: fixed;
    display: inline-flex;
    width: 0.25rem;
    left: 49.5%;
    height: 100%;
    background: #00bcd4;
    color: #fff;
    font-size: 18px;
    display: flex;
    /* cursor: pointer; */
    align-items: center;
  }
  .modelListOne {
    position: absolute;
    top: 2%;
    left: 2%;
  }
  .modelListTwo {
    position: absolute;
    top: 2%;
    left: 52%;
  }
}
/* 新增 */
.myborder-el-button {
  position: absolute;
  top: 39%;
  left: -1.9rem;
}
.model3 {
  left: 49.6%;
  width: 50.4%;
}
</style>
